module.exports = __webpack_public_path__ + "img/方块1.0bdb090b.png";